export default "__VITE_ASSET__CjLofMIz__"